import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
export function TranscriptFeed({ entries }) {
    const bottomRef = useRef(null);
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [entries]);
    if (entries.length === 0) {
        return (_jsx("div", { style: {
                color: "rgba(255,255,255,0.2)", fontSize: 12,
                textAlign: "center", padding: "32px 0", fontWeight: 500,
            }, children: "Transcript will appear here\u2026" }));
    }
    return (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [entries.slice(-30).map((entry) => (_jsxs("div", { style: {
                    display: "flex",
                    gap: 9,
                    opacity: entry.isFinal ? 1 : 0.45,
                    transition: "opacity 0.2s ease",
                }, children: [_jsx("span", { style: {
                            fontSize: 10,
                            fontWeight: 700,
                            color: entry.speaker === "user"
                                ? "rgba(139,92,246,0.8)"
                                : "rgba(255,255,255,0.3)",
                            textTransform: "uppercase",
                            letterSpacing: "0.06em",
                            minWidth: 32,
                            paddingTop: 2,
                            flexShrink: 0,
                        }, children: entry.speaker === "user" ? "You" : "Them" }), _jsxs("p", { style: {
                            fontSize: 12,
                            color: entry.isFinal ? "rgba(255,255,255,0.75)" : "rgba(255,255,255,0.45)",
                            lineHeight: 1.55,
                            margin: 0,
                        }, children: [entry.text, !entry.isFinal && _jsx("span", { style: { opacity: 0.4, marginLeft: 2 }, children: "\u258C" })] })] }, entry.id))), _jsx("div", { ref: bottomRef })] }));
}
